<!-- 优惠券商品列表 -->
<template>
  <div class="container">
    <div class="tabs" v-if="isShowTabs">
      <div class="tab tabs-story" :class="{'active': currentTab == 'audio'}" v-if="audioList.length" data-type="audio" @click="selectList">故事</div>
      <div class="tab tabs-pkg" :class="{'active': currentTab == 'pkg'}" v-if="pkgList.length" data-type="pkg" @click="selectList">套装</div>
      <div class="tab tabs-vip" :class="{'active': currentTab == 'vip'}" v-if="vipList.length" data-type="vip" @click="selectList">会员</div>
    </div>
    <div class="main">
      <div class="goods">
        <goods-list class="goods-list" :list="list"></goods-list>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsList from './goods-list'
import pkgData from './topic-pkg/pkgData'
import { getCouponSpecInfo, getCouponAudioGoodsList } from '@/api/coupon'
import { isIlistenIos, isIlistenAndroid } from '@/utils/app-helper'

export default {
  components: { GoodsList },
  data() {
    return {
      audioList: [],
      pkgList: [],
      vipList: [
        {
          type: 'vip',
          goodId: 2514,
          name: '1年VIP会员',
          icon: 'vip-12.png',
          price: 27800,
          priceLabel: '365.00'
        },
        {
          type: 'vip',
          goodId: 2611,
          name: '6个月VIP会员',
          icon: 'vip-6.png',
          price: 14800,
          priceLabel: '240.00'
        },
        {
          type: 'vip',
          goodId: 2610,
          name: '3个月VIP会员',
          icon: 'vip-3.png',
          price: 7800,
          priceLabel: '120.00'
        },
        {
          type: 'vip',
          goodId: 2938,
          name: '1个月VIP会员',
          icon: 'vip-1.png',
          price: 4000,
          priceLabel: '40.00'
        },
        {
          type: 'vip',
          goodId: 7620,
          name: '1个月VIP会员',
          icon: 'vip-1.png',
          price: 3500,
          priceLabel: '35.00'
        },
      ],
      list: [],
      currentTab: 'audio',
      isShowTabs: false,
      couponSpecInfo: {},
      iconPrefix: 'https://img-ilisten.idaddy.cn/'
    }
  },
  async created() {
    let {
      coupon_spec_id: couponSpecId,
      topic_audio_id: topicAudioId,
      topic_pkg_id: topicPkgId
    } = this.$route.query
    console.log(couponSpecId, topicAudioId, topicPkgId)

    this.$daidiLoading.show({
      text: '加载商品中，请稍候...',
    })

    try {
      let topicAudioList = topicAudioId ? topicAudioId.split(',') : []

      let couponSpecInfo = await this.getCouponSpecInfo(couponSpecId)
      let couponGoodsList = couponSpecInfo.goods_list || []

      console.log(couponGoodsList)

      if (topicAudioId) {
        for (let i = 0; i < topicAudioList.length; i++) {
          await this.getCouponAudioGoodsList(topicAudioList[i], couponSpecId)
        }
      }
      if (topicPkgId) {
        this.getPkgList(topicPkgId)
      }

      this.initVipList()

      // 展示tab
      if (this.checkListIsEmpty(this.audioList)
        + this.checkListIsEmpty(this.pkgList)
        + this.checkListIsEmpty(this.vipList)
        > 1) {
          this.isShowTabs = true
        }

      this.initSelectedList()

    } catch (err) {
      console.error(err)
      this.$toast.show({
        text: '数据读取失败<br>请稍后再试',
        duration: '10000'
      })
    }

    this.$daidiLoading.hide()

    if (!this.list.length) {
      this.$toast.show({
        text: '目前没有可用商品',
        duration: '6000'
      })
    }
  },
  async mounted() {
    
  },
  methods: {
    checkListIsEmpty (list) {
      return list.length ? 1 : 0
    },

    initSelectedList () {
      if (this.audioList.length) {
        this.list = this.audioList
        this.currentTab = 'audio'
        return
      }
      if (this.pkgList.length) {
        this.list = this.pkgList
        this.currentTab = 'pkg'
        return
      }
      if (this.vipList.length) {
        this.list = this.vipList
        this.currentTab = 'vip'
        return
      }
    },

    async getCouponSpecInfo (couponSpecId) {
      let couponSpecInfo = await getCouponSpecInfo(couponSpecId)
      this.couponSpecInfo = couponSpecInfo.coupon_spec_info
      return couponSpecInfo.coupon_spec_info
    },

    async getCouponAudioGoodsList (topicId, couponSpecId) {
      console.log(topicId)
      let list = await getCouponAudioGoodsList(topicId, couponSpecId, this.$store.getters.userId)
      let audioList = this.audioList
      list.list.forEach((item, index) => {
        let discountPriceLabel = item.goods.couponed_price_label
        if (+discountPriceLabel <= 0) {
          discountPriceLabel = '0.01'
        }
        let couponGoodsList = this.couponSpecInfo.goods_list || []
        for (let i = 0; i < couponGoodsList.length; i++) {
          if (couponGoodsList[i].good_type === 'audio' && (couponGoodsList[i].good_id == '0' || couponGoodsList[i].good_id == item.goods.good_id)) {
            audioList.push({
              type: 'audio',
              name: item.audio_name,
              icon: item.audio_icon,
              iconRoute: `ilisten:///audio/info?id=${item.audio_id}`,
              audioId: item.audio_id,
              goodId: item.goods.good_id,
              price: item.goods.good_price,
              priceLabel: item.goods.good_price_label,
              discountPrice: item.goods.discounted_price,
              discountPriceLabel: discountPriceLabel,
            })
          }
        }
      })
      this.audioList = audioList
    },

    getPkgList(topicId) {
      let list = pkgData[topicId]
      let pkgList = []
      console.log(this.couponSpecInfo)
      list.forEach(item => {
        let couponGoodsList = this.couponSpecInfo.goods_list || []
        for (let i = 0; i < couponGoodsList.length; i++) {
          if (couponGoodsList[i].good_type === 'pkg' && (couponGoodsList[i].good_id == '0' || couponGoodsList[i].good_id == item.good_id)) {
            let newItem = {}
            newItem.icon = this.iconPrefix + item.pkg_pic
            newItem.name = item.pkg_name
            newItem.goodId = item.good_id
            newItem.type = item.obj_type
            newItem.iconRoute = `ilisten:///package/info?id=${item.good_id}`,
            newItem.price = item.good_price
            newItem.priceLabel = Number(item.good_price / 100).toFixed(2)
            // 调换执行顺序有优化空间
            if (this.couponSpecInfo.discount_type == 'relief') {
              if (item.good_price >= this.couponSpecInfo.min_price) {
                
                let price = Number((item.good_price - this.couponSpecInfo.discount_value) / 100)
                if (price < 0.01) {
                  price = 0.01
                }
                newItem.discountPriceLabel = price.toFixed(2)
                pkgList.push(newItem)
              }
            } else {
              let price = Number((item.good_price * this.couponSpecInfo.discount_value / 100) / 100)
              if (price < 0.01) {
                price = 0.01
              }
              newItem.discountPriceLabel = price.toFixed(2)
              pkgList.push(newItem)
            }
          }
        }
      })
      this.pkgList = pkgList
    },

    initVipList () {
      let list = []
      this.vipList.forEach(item => {
        let couponGoodsList = this.couponSpecInfo.goods_list || []
        for (let i = 0; i < couponGoodsList.length; i++) {
          if (couponGoodsList[i].good_type === 'vip' && (couponGoodsList[i].good_id == '0' || couponGoodsList[i].good_id == item.goodId)) {
            let newItem = item
            item.icon = require('@/assets/coupon/' + item.icon)
            item.discountPriceLabel = this.couponSpecInfo
            if (this.couponSpecInfo.discount_type == 'relief') {
              if (item.priceLabel * 100 >= this.couponSpecInfo.min_price) {
                newItem.discountPriceLabel = Number((item.price - this.couponSpecInfo.discount_value) / 100).toFixed(2)
                list.push(newItem)
              }
            } else {
              let price = Number((item.price * this.couponSpecInfo.discount_value / 100) / 100)
              if (price < 0.01) {
                price = 0.01
              }
              newItem.discountPriceLabel = price.toFixed(2)
              list.push(newItem)
            }
          }
        }
      })
      
      list = list.filter(item => {
        if (isIlistenIos()) {
          return item.goodId != 7620
        }
        if (isIlistenAndroid()) {
          return item.goodId != 2938
        }
      })

      this.vipList = list
    },

    selectList(e) {
      if (this.currentTab == e.target.dataset.type) return
      this.currentTab = e.target.dataset.type
      switch (e.target.dataset.type) {
        case 'audio':
          this.list = this.audioList
          break
        case 'pkg':
          this.list = this.pkgList
          break
        case 'vip':
          this.list = this.vipList
          break
      }
    }
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.tabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: .88rem;
  border-bottom: 1px solid rgba(0,0,0,.1);
  .tab {
    position: relative;
    display: inline-block;
    font-size: .28rem;
    color: #6c6c74;
    text-align: center;
  }
  .active {
    font-size: .34rem;
    color: #feb800;
    font-weight: bold;
    &::after {
      position: absolute;
      content: "";
      display: block;
      left: 50%;
      bottom: -.1rem;
      transform: translateX(-50%);
      width: .56rem;
      height: .04rem;
      background: #feb800;
    }
  }
}
</style>
